import { flatten } from 'flat';
import en from './en';
import de from './de';

// react-intl takes flat messages: https://stackoverflow.com/questions/45783677/react-intl-accessing-nested-messages
const messages: Record<string, Record<string, string>> = {
  en: flatten(en),
  de: flatten(de),
};

export default messages;
